import { gql } from '@apollo/client';

export const ACTIVITY_CREATE = gql`
	mutation ActivityCreate($idempotencyKey: String!, $input: ActivityInput!) {
		ActivityCreate(idempotencyKey: $idempotencyKey, input: $input) {
			activity {
				id
				comment
				createdAt
			}
		}
	}
`;

export const ACTIVITY_UPDATE = gql`
	mutation ActivityUpdate(
		$id: Identifier!
		$idempotencyKey: String!
		$input: ActivityInput!
	) {
		ActivityUpdate(
			id: $id
			idempotencyKey: $idempotencyKey
			input: $input
		) {
			activity {
				id
				comment
				updatedAt
			}
		}
	}
`;
